const WildcardClient = require("./WildcardClient");

module.exports = new WildcardClient();
